{
  "info": "정보",
  "negative": "오류",
  "notice": "경고",
  "positive": "성공"
}
